module.exports = __webpack_public_path__ + "static/media/Image_greentours@2x.fe5c6645.jpg";